import { useQuery, gql } from '@apollo/client';
import { useSelector } from 'react-redux';

export function useOverview() {
  const {
    waterQuality: {
      filterFlowrates: {
        register: { year, week, day, dataPoint },
      },
    },
  } = useSelector(({ state }) => state);

  let variables = { week, year, day };
  const { data = { DataFlowratesLog: [] }, loading } = useQuery(GET_OVERVIEW, {
    variables,
    skip: skip(variables),
  });

  let dataOverview = [];
  data.DataFlowratesLog.forEach((rows) => {
    if (rows.data_point !== dataPoint) return;
    dataOverview.push(rows);
  });
  return { loading, data: dataOverview };
}

function skip(variables) {
  let skip = true;
  let { year, week, day } = variables;
  skip = ![year, week, day].every((v) => v);
  return skip;
}

const GET_OVERVIEW = gql`
  query ResponseFlowratesLog($year: Int!, $week: Int!, $day: Int!) {
    DataFlowratesLog: ResponseFlowratesLog(year: $year, week: $week, day: $day) {
      _id
      year
      week
      day
      data_point
      data_value
      hours_ori
      hours_apo
    }
  }
`;
